module.exports = __webpack_public_path__ + "img/radio_zet.ccff1297.png";